import { useState } from 'react';
import { useLanguageContext } from '../../contexts/LanguageContext';
import './Data.scss';

function MultiLineData({ label, value, large, bgColor, suffix, asHtml, translatable, naturalWidth }) {
  const { currentLanguage } = useLanguageContext();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    setCopied(true);
    // Copy to clipboard
    await navigator.clipboard.writeText(value);
    setTimeout(() => {
      setCopied(false);
    }, 2500);
  };

  const formatValue = () => {
    if (!suffix) return value;
    return `${value} ${suffix}`;
  };

  return (
    <div
      onClick={handleCopy}
      className={`flex flex-col gap-y-1 cursor-pointer data-container ${naturalWidth ? "w-auto" : large ? 'w-[700px]' : 'w-[340px]'
        }`}>
      {label && <div className="w-full flex flex-row justify-between items-center">
        <div className="flex flex-row gap-x-2 items-center">
          <span className="text-slate-500 text-sm">{label}</span>
          {translatable && <span className={`text-xs fi fi-${currentLanguage.code}`}></span>}
        </div>
        <i
          className={`pi pi-copy copy-icon ${copied ? 'opacity-1 text-green-500' : 'opacity-0 text-slate-300'
            }`}
        />
      </div>}
      <div className={`relative ${value ? '' : 'text-slate-400 italic font-extralight'}`}>
        {!asHtml && <p>{value ? formatValue() : 'Non renseigné'}</p>}
        {asHtml && (
          <div dangerouslySetInnerHTML={{ __html: value ? value : '<p>Non renseigné</p>' }}></div>
        )}
      </div>
    </div>
  );
}

export default MultiLineData;
